import oRoot from "@zasada/bootstrap";
import oBrigadaBox from 'brigada/src/index.js';
import { Layers } from 'base/assets/js/widget/Layers.js'
import { Frame } from 'base/assets/js/widget/Frame.js'
import {FormField as FormFieldOrigin} from "brigada/src/widget/FormField.js";
import { Request } from 'base/assets/js/lib/Request.js'

oBrigadaBox.oneLinker = oRoot.core.oneLinker;
oBrigadaBox.oneStorage = oRoot.core.oneStorage;
oBrigadaBox.newRelQuery = oRoot.core.newRelQuery;

// свои подмены
class FormField extends FormFieldOrigin {
  bOnChange = true;
  bOnType = false;
  oMods = {
    process: 'form-group_process',
    success: 'form-group_valid',
    error: 'form-group_invalid'
  };
}
oBrigadaBox.FormField = FormField;
oBrigadaBox.Layers = Layers;
oBrigadaBox.Frame = Frame;
oBrigadaBox.Request = Request;

oRoot.brigada = oBrigadaBox;
export default oRoot;